import { Component } from 'react';
import Announcement from '../../../components/Announcement';
import Loading from '../../../components/Loading';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import { createData } from './config';
import { activateMessage } from '../../../helpers/messages';
import { withTranslation } from 'react-i18next';

class GSCReportAnnouncement extends Component {
    constructor() {
        super();

        this.createButton = this.createButton.bind(this);
        this.createLink = this.createLink.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.endTrial = this.endTrial.bind(this);

        this.state = {
            buttonName: '',
            isLink: false,
            href: '',
            isOpen: false,
            loading: false,
            onClick: () => {},
        };
    }

    componentDidMount() {
        if (window.user_permissions?.subscription_status === 'trialing') this.createButton();
    }

    createButton() {
        this.setState({
            buttonName: this.props.t('search.announcement.subscription.activate'),
            onClick: this.onOpenModal,
        });
    }

    endTrial() {
        this.setState({ loading: true });
        let url = '/customers/end-trial/';
        if (this.props.domain_id) url = url + `?domain=${this.props.domain_id}`;
        fetch(url, {
            method: 'POST',
            headers: {
                'X-CSRFToken': window.csrf_token,
            },
        })
            .then((res) => res.json())
            .then(() => {
                window.location.reload();
            })
            .catch((err) => {
                this.setState({ loading: false });
                console.log(err);
            });
    }

    createLink() {
        this.setState({
            buttonName:
                this.props.plan_type === 'Basic'
                    ? this.props.t('search.announcement.subscription.upgrade')
                    : this.props.t('search.announcement.subscription.activate_upgrade'),
            isLink: true,
            href: `${this.props.current_url}/customers/change_plan/?without_basic=True`,
        });
    }

    onOpenModal() {
        this.setState({ isOpen: true });
    }

    onCloseModal() {
        this.setState({ isOpen: false });
    }

    render() {
        const { t } = this.props;
        const content = createData(this.props);
        return (
            <>
                <Announcement
                    image={this.props.announcement_image}
                    buttonName={this.state.buttonName}
                    onClick={this.state.onClick}
                    message={this.props.message}
                    isLink={this.state.isLink}
                    href={this.state.href}
                    announcement_bar_styles={this.props.announcement_bar_styles || 'bg-warning'}
                    buttonStyles={this.props.button_styles || 'bg-khaki'}
                    loading={this.state.loading}
                />

                {content.map((item, i) => {
                    return (
                        <div key={i} className="show-sample-container">
                            <div className="row card-row d-flex" id="authors-content">
                                <div className="col-12">
                                    <div className="card table-main rounded-main overflow-hidden">
                                        <div className="card-header">
                                            <div className="card-title">{item.label}</div>
                                            {item.description && (
                                                <small className="d-block card-sub-title text-muted text-capitalize py-2">
                                                    {item.description}
                                                </small>
                                            )}
                                        </div>
                                        <div className="card-body">
                                            <img src={item.image} alt={item.label} loading="lazy" />
                                            <div className="redirect-button">
                                                {this.state.isLink ? (
                                                    <a
                                                        className="bg-khaki button-close"
                                                        href={this.state.href}
                                                    >
                                                        {this.state.buttonName}
                                                    </a>
                                                ) : (
                                                    <div>
                                                        <button
                                                            className={'bg-khaki button-close'}
                                                            onClick={this.state.onClick}
                                                            disabled={this.state.loading}
                                                        >
                                                            {this.state.buttonName}
                                                        </button>
                                                        <div className="d-flex justify-content-center pt-2">
                                                            {this.state.loading && (
                                                                <Loading onlyPreloader />
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
                <ConfirmationModal
                    isOpen={this.state.isOpen}
                    message={activateMessage}
                    onClose={this.onCloseModal}
                    onSubmit={this.endTrial}
                    cancleBtn={t('search.announcement.subscription.continue_trial')}
                    buttonName={t('search.announcement.subscription.activate_paid_plan')}
                />
            </>
        );
    }
}

export default withTranslation()(GSCReportAnnouncement);
